import { createSlice } from '@reduxjs/toolkit';
import { RP_TYPE } from '../../../config/constant/unityConstants';

const renderPreviewPoppup = createSlice({
  name: 'renderPreviewPoppup',
  initialState: {
    popupType: false,
    selectedCameraIds: [],
    moreInfo: null,
    isInviteActive: false,
  },
  reducers: {
    setOpen: (state, { payload }) => {
      state.popupType = payload
    },
    openMoreInfo: (state, { payload }) => {
      state.moreInfo = payload;
    },
    closeMoreInfo: (state, { payload }) => {
      state.moreInfo = null;
    },
    openInvite: (state) => {
      state.isInviteActive = true;
    },
    closeInvite: (state) => {
      state.isInviteActive = false;
    },
  },
});

export const {
  setOpen,
  openMoreInfo,
  closeMoreInfo,
  openInvite,
  closeInvite,
} = renderPreviewPoppup.actions;
export const renderPreviewPoppupSelector = (state) => state.renderPreviewPoppup;
export const renderPreviewPoppupReducer = renderPreviewPoppup.reducer;
export default renderPreviewPoppupReducer;

export const selectOpen = (state) => Boolean(state.renderPreviewPoppup.popupType);
export const selectPopupType = (state) => state.renderPreviewPoppup.popupType;

export const selectMoreInfoPopup = (state) => state.renderPreviewPoppup.moreInfo;

export const selectIsQuickViewTabActive = (state) => state.renderPreviewPoppup.popupType === RP_TYPE.PREVIEW;
export const selectIsHighResolutionTabActive = (state) => state.renderPreviewPoppup.popupType === RP_TYPE.RENDER;

export const selectIsInviteActive = (state) => state.renderPreviewPoppup.isInviteActive;